import Navbar from '@/components/Navbar/navbar.component.vue'
import Mediabar from '@/components/Mediabar/mediabar.component.vue'
import Footer from '@/components/Footer/footer.component.vue'

require('vue2-animate/dist/vue2-animate.min.css')

export default {
    name: 'App',
    components: {
        Navbar,
        Mediabar,
        Footer,
    }
}